import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

const Dependents = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [dependents, setDependents] = useState([
        {
            id: 1,
            name: "Pradeep Kumar",
            relationship: "Father",
            dob: "1985-07-10",
            occupation: "Job",
            monthlyIncome: "100000.00",
        },
    ]);

    const handleChange = (id, e) => {
        const { name, value } = e.target;
        setDependents((prevDependents) =>
            prevDependents.map((dependent) =>
                dependent.id === id ? { ...dependent, [name]: value } : dependent
            )
        );
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    const handleAddRow = () => {
        setDependents([
            ...dependents,
            {
                id: dependents.length + 1,
                name: "",
                relationship: "Father",
                dob: "",
                occupation: "",
                monthlyIncome: "",
            },
        ]);
    };

    const handleDeleteRow = (id) => {
        setDependents(dependents.filter((dependent) => dependent.id !== id));
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Dependents</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="table-responsive">
                    <table className="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Relationship</th>
                                <th>DOB</th>
                                <th>Occupation</th>
                                <th>Monthly Income</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dependents.map((dependent) => (
                                <tr key={dependent.id}>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control input-me f-14"
                                                value={dependent.name}
                                                onChange={(e) => handleChange(dependent.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{dependent.name}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <select
                                                name="relationship"
                                                className="form-control input-me f-14"
                                                value={dependent.relationship}
                                                onChange={(e) => handleChange(dependent.id, e)}
                                            >
                                                <option>Father</option>
                                                <option>Mother</option>
                                                <option>Brother</option>
                                                <option>Sister</option>
                                                <option>Son</option>
                                                <option>Daughter</option>
                                            </select>
                                        ) : (
                                            <p className="mb-0 f-13">{dependent.relationship}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="date"
                                                name="dob"
                                                className="form-control input-me f-14"
                                                value={dependent.dob}
                                                onChange={(e) => handleChange(dependent.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{dependent.dob}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="occupation"
                                                className="form-control input-me f-14"
                                                value={dependent.occupation}
                                                onChange={(e) => handleChange(dependent.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{dependent.occupation}</p>
                                        )}
                                    </td>
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                name="monthlyIncome"
                                                className="form-control input-me f-14"
                                                value={dependent.monthlyIncome}
                                                onChange={(e) => handleChange(dependent.id, e)}
                                            />
                                        ) : (
                                            <p className="mb-0 f-13">{dependent.monthlyIncome}</p>
                                        )}
                                    </td>
                                    <td align="right">
                                        <button className="btn text-danger p-0 f-12" onClick={() => handleDeleteRow(dependent.id)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button className="btn btn-primary btn-sm mt-2" onClick={handleAddRow}>
                        <FontAwesomeIcon icon={faPlus} /> Add More
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Dependents;
